import { themeObject } from 'lib';

export const templateWrapperStyles = {
    headerBox: { display: 'flex', m: 3 },
    bodyContainerStyles: {
        display: 'flex',
        flexDirection: 'row',
        gap: '20px',
    },
    contentContainerStyles: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        border: `1px solid ${themeObject.palette.grayScale[300]}`,
        backgroundColor: themeObject.palette.background.default,
        p: '32px 24px',
        borderRadius: '5px',
        overflow: 'auto',
    },
    headingTextStyles: {
        ...themeObject.typography.h3,
        color: themeObject.palette.primary[700],
    },
    emptyContainerStyles: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        gap: 4,
    },
    emptyStepsImageStyles: {
        width: '106px',
        height: '112px',
    },
    addButtonStyles: {
        borderRadius: '64px',
        width: '130px',
        height: '40px',
        '& .MuiTypography-root': {
            fontFamily: 'Red Hat Text',
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '24px',
            color: themeObject.palette.grayScale[700],
        },
    },
    headerButtonStyles: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 1.5,
    },
};
